<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options"/>
    <basic-table
      v-if="servicesInTariffs"
      :items="servicesInTariffs"
      :fields="servicesInTariffsFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <b-modal hide-footer :title="$t('One-time service')" ref="modalOnceService">
      <FormOnceServices
      @hideModalServices="hideModalServices"
      :isTariffs="isTariffs"
      :isEdit="isEdit"
      :currentRowService="selectedServices"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Periodic service')" ref="modalPeriodicService">
      <FormPeriodicServices
      @hideModalServices="hideModalServices"
      :isTariffs="isTariffs"
      :isEdit="isEdit"
      :currentRowService="selectedServices"/>
    </b-modal>

    <b-modal hide-footer :title="$t('IP traffic service')" ref="modalIPtrafficService" size="lg">
      <FormIPtrafficService
      @hideModalServices="hideModalServices"
      :isTariffs="isTariffs"
      :isEdit="isEdit"
      :currentRowService="selectedServices"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Hotspot service')" ref="modalHotspotService" size="lg">
      <FormHotspotServices
      @hideModalServices="hideModalServices"
      :isTariffs="isTariffs"
      :isEdit="isEdit"
      :currentRowService="selectedServices"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Dial-up service')" ref="modalDialupService" size="lg">
      <FormDialupServices
      @hideModalServices="hideModalServices"
      :isTariffs="isTariffs"
      :isEdit="isEdit"
      :currentRowService="selectedServices"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Telephony service')" ref="modalTelephoneService" size="lg">
      <FormTelephoneService
      @hideModalServices="hideModalServices"
      :isTariffs="isTariffs"
      :isEdit="isEdit"
      :currentRowService="selectedServices"/>
    </b-modal>

    <b-modal hide-footer :title="$t('IPTV service')" ref="modalIPTVService" size="lg">
      <FormIPTVService
      @hideModalServices="hideModalServices"
      :isTariffs="isTariffs"
      :isEdit="isEdit"
      :currentRowService="selectedServices"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Video on demand')" ref="modalVodService" size="lg">
      <FormVodService
      @hideModalServices="hideModalServices"
      :isTariffs="isTariffs"
      :isEdit="isEdit"
      :currentRowService="selectedServices"/>
    </b-modal>
  </div>
</template>

<script>
import FormOnceServices from '../formOnceService'
import FormPeriodicServices from '../formPeriodicService'
import FormIPtrafficService from '../formIPtrafficService'
import FormHotspotServices from '../formHotspotService'
import FormDialupServices from '../formDialupService'
import FormTelephoneService from '../formTelephonyService'
import FormIPTVService from '../formIPTVService'
import FormVodService from '../formVodService'

export default {
  components: {
    FormOnceServices,
    FormPeriodicServices,
    FormIPtrafficService,
    FormHotspotServices,
    FormDialupServices,
    FormTelephoneService,
    FormIPTVService,
    FormVodService
  },
  data () {
    return {
      servicesInTariffsFields: [
        {key: 'service_id', label: 'ID', sortable: true},
        {key: 'service_name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'nameServicesType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'comment', label: this.$i18n.t('Comment'), sortable: true},
        {key: 'tariffName', label: this.$i18n.t('Status'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      isTariffs: true,
      isEdit: true,
      selectedServices: null,
      options: {
        isShowAddButton: false
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    hideModalServices () {
      this.$refs.modalOnceService.hide()
      this.$refs.modalPeriodicService.hide()
      this.$refs.modalIPtrafficService.hide()
      this.$refs.modalDialupService.hide()
      this.$refs.modalHotspotService.hide()
      this.$refs.modalIPTVService.hide()
      this.$refs.modalVodService.hide()
      this.$refs.modalTelephoneService.hide()
    },
    editItem (item) {
      this.selectedServices = JSON.parse(JSON.stringify(item))
      switch (this.selectedServices.service_type) {
        case 1:
          this.$refs.modalOnceService.show()
          break
        case 2:
          this.$refs.modalPeriodicService.show()
          break
        case 3:
          this.$refs.modalIPtrafficService.show()
          break
        case 4:
          this.$refs.modalHotspotService.show()
          break
        case 5:
          this.$refs.modalDialupService.show()
          break
        case 6:
          this.$refs.modalTelephoneService.show()
          break
        case 8:
          this.$refs.modalIPTVService.show()
          break
        case 9:
          this.$refs.modalVodService.show()
          break
      }
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Service"?'), this.deleteItem, item)
    },
    async deleteItem (item) {
      await this.$store.dispatch('Tariffing/GET_TARIFF_LINKS_COUNT', item.service_id).then(response => {
        let linksCount = this.$store.getters['Tariffing/TARIFF_LINKS_COUNT']
        if (linksCount.links_count > 0) {
          this.$root.$emit('makeToasts', 'warning', this.$i18n.t('Cannot delete service, service links count:') + linksCount.links_count, 'Warning')
        } else {
          let response = this.$store.dispatch('Tariffing/DELETE_SERVICES', item.service_id)
          response.then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            } else {
              setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
              this.$root.$emit('makeToasts')
            }
          })
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    servicesInTariffs () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/SERVICES']))
      copy = copy.filter(function (value) {
        return value.tariff_id !== 0
      })
      for (let el of copy) {
        for (let elTariffs of this.$store.getters['Tariffing/TARIFFS']) {
          if (el.tariff_id === elTariffs.id) {
            el.tariffName = this.$i18n.t('Tariff plan: "') + elTariffs.name + '"' + ' (' + elTariffs.id + ')'
          }
        }
        switch (el.service_type) {
          case 1:
            el.nameServicesType = this.$i18n.t('One-time service link')
            break
          case 2:
            el.nameServicesType = this.$i18n.t('Periodic service link')
            break
          case 3:
            el.nameServicesType = this.$i18n.t('IP traffic service link')
            break
          case 4:
            el.nameServicesType = this.$i18n.t('Hotspot service link')
            break
          case 5:
            el.nameServicesType = this.$i18n.t('Dial-up service link')
            break
          case 6:
            el.nameServicesType = this.$i18n.t('Telephony service link')
            break
          case 8:
            el.nameServicesType = this.$i18n.t('IPTV service link')
            break
          case 9:
            el.nameServicesType = this.$i18n.t('Video on demand')
            break
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_SERVICES')
    this.$store.dispatch('Tariffing/GET_TARIFFS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/servicesInTariffs/main.vue